import React from 'react';
import { BatteryCharging, RotateCw, SunMedium, Hand } from 'lucide-react';
import { Section } from './Section';
const benefits = [{
  icon: BatteryCharging,
  title: 'Batería recargable',
  description: 'USB-C de larga duración.'
}, {
  icon: RotateCw,
  title: 'Brazo flexible',
  description: 'Se adapta a tu posición.'
}, {
  icon: SunMedium,
  title: '3 intensidades de luz',
  description: 'Cálida, neutra y blanca.'
}, {
  icon: Hand,
  title: 'Uso manos libres',
  description: 'Diseño ergonómico al cuello.'
}];
export function Benefits() {
  return <Section id="detalles" className="border-t border-black/5" data-id="element-11">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12 md:gap-x-8" data-id="element-12">
        {benefits.map((benefit, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-13">
            <div className="w-16 h-16 rounded-2xl bg-[#FF6B1A]/10 flex items-center justify-center mb-6 text-[#FF6B1A] group-hover:bg-[#FF6B1A] group-hover:text-white transition-all duration-300" data-id="element-14">
              <benefit.icon strokeWidth={1.5} size={28} data-id="element-15" />
            </div>
            <h3 className="text-lg font-semibold mb-2" data-id="element-16">{benefit.title}</h3>
            <p className="text-sm text-[#6B6B6B] font-light text-balance" data-id="element-17">
              {benefit.description}
            </p>
          </div>)}
      </div>
    </Section>;
}